<div class="d-flex flex-column gap-space-4">
    <div class="v3">
        <div [ngClass]="{ 'sb-form-field-label': kind() !== FormContainerKind.Switch, 'sb-form-field-label-switch': kind() === FormContainerKind.Switch }">
            <div class="sb-form-field-label-text-wrapper">
                <label
                    [for]="formFieldID()"
                    [id]="formFieldID() + '-label'">
                    <ng-content></ng-content>
                </label>
                @if (!isDisabled() && isRequired() && kind() !== FormContainerKind.Radio && !isReadonly()) {
                    <!-- eslint-disable-next-line -->
                    <span aria-hidden="true" class="sb-form-field-label-asterisk">*</span>
                }
            </div>

            <ng-content select="[helper]"></ng-content>
        </div>
    </div>
</div>
